var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-body"},[(_vm.$parentInfo.powers.includes(151))?_c('el-button',{on:{"click":function($event){return _vm.handleSwapDate()}}},[_vm._v("互换日期课程")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }